import deleteTag from 'api/v2/repository/deleteTag';
import { useMutation, useQueryClient } from 'react-query';
import { DocumentsRepositoryCacheKeys } from 'types/cacheKeys.types';
import showToast from 'utils/toast';

const useDeleteTag = () => {
  const queryClient = useQueryClient();

  const deleteTagAPI = useMutation({
    mutationFn: deleteTag,
    onSuccess: () => {
      showToast({ title: 'Tag deleted successfully' }, { type: 'success' });

      queryClient.invalidateQueries([DocumentsRepositoryCacheKeys.AllTags]);
    },
  });

  return deleteTagAPI;
};

export default useDeleteTag;
